import { render, staticRenderFns } from "./ModalYoga.vue?vue&type=template&id=e4bc67c8&"
import script from "./ModalYoga.vue?vue&type=script&lang=js&"
export * from "./ModalYoga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports